/* eslint-disable react-hooks/exhaustive-deps */
import { FC, memo, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { FaEye, FaPencilAlt, FaTrashAlt } from 'react-icons/fa'

import {
  Button,
  Tooltip,
  useTheme,
} from '@mui/material'

import { IColumn } from 'types'
import { useNavigate } from 'react-router-dom'
import MainTableActionButtons from 'components/organisms/MainTableActionButtons'
import { translateGradeLevel } from 'utils/helpers'

export const useTableModel = () => {
  const { t } = useTranslation()

  const handleActionsFormat = useCallback(
    (cellValue: string, row: any, index: number) => <MainTableActionButtons baseUrl='/groups/' row={row} />,
    [],
  )
  const handleGradeLevelFormat = useCallback(
    (cellValue: string, row: any) => translateGradeLevel(row.grade_level, true) ,
    [],
  )
  
  const columns: IColumn[] = [
    {
      title: `${t('common.academic-year')}`,
      field: 'academic_year',
      order: true,
      width: '15%',
    },
    {
      title: `${t('common.grade-level')}`,
      field: 'grade_level',
      order: true,
      width: '15%',
      format: handleGradeLevelFormat,
    },
    {
      title: `${t('common.sign')}`,
      field: 'sign',
      order: true,
      width: '20%',
    },
    {
      title: `${t('common.mentor')}`,
      field: 'mentor',
      width: '40%',
      order: true,
    },
    {
      title: '',
      field: '',
      align: 'end',
      width: '10%',
      order: false,
      format: handleActionsFormat,
    },
  ]

  return columns
}
